import { render, staticRenderFns } from "./CarrierDestinationPriceList.vue?vue&type=template&id=589ee322&scoped=true&"
import script from "./CarrierDestinationPriceList.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ee322",
  null
  
)

export default component.exports